<template>
	<div>
	<Login v-if="$route.name == 'Login'" />
	<div v-else id="demo" :class="[{ 'collapsed': collapsed }, { 'onmobile': isOnMobile }]"
		@mousemove="updateLastActiveTime" @keypress="updateLastActiveTime" @click="updateLastActiveTime">
		<div class="demo">
		<div class="container-new">
			<router-view />
		</div>
		<AppHeader />
		<AppSidebar @toggle-collapse="onToggleCollapse" />
		<!-- <div
			v-if="isOnMobile && !collapsed"
			class="sidebar-overlay"
			@click="collapsed = true"
		></div> -->
		</div>
	</div>
	<div class="modal fade" id="popupModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
		aria-labelledby="popupModalLabel" aria-hidden="true">
		<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
			<h5 class="modal-title fw-bold" id="staticBackdropLabel">Session Expired</h5>
			<!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="redirectToLogin"></button> -->
			</div>
			<div class="modal-body">
			Your session has expired due to inactivity. Login again
			</div>
			<div class="modal-footer">
			<button type="button" class="btn btn-primary" @click="redirectToLogin">Login</button>
			<!-- <button type="button" class="btn btn-danger" @click="redirectToLogin">No</button> -->
			</div>
		</div>
		</div>
	</div>

	</div>
	</template>

	<script>
	import AppSidebar from './components/sidebar/sidebar.vue'
	import AppHeader from './components/header/header.vue';
	import Login from './components/login/login.vue';
	const config = require('./../config.json');
	const requestHelper = require('./helpers/requestHelper');

	export default {
	name: 'App',
	components: {
		AppHeader, AppSidebar, Login
	},
	data() {
		return {
		collapsed: false,
		themes: [
			{
			name: 'Default theme',
			input: ''
			},
			{
			name: 'White theme',
			input: 'white-theme'
			}
		],
		selectedTheme: '',
		isOnMobile: false
		}
	},
	methods: {
		onResize() {
		if (window.innerWidth <= 876) {
			this.isOnMobile = true
			this.collapsed = true
		} else {
			this.isOnMobile = false
			this.collapsed = false
		}
		},
		onToggleCollapse(collapsed) {
		// alert(collapsed);
		this.isOnMobile = collapsed
		},
		updateLastActiveTime() {
		this.$store.dispatch('updateLastActiveTime');
		},
		redirectToLogin() {
		window.location.href = `${config.clarityPayAdminUrl}/login`
		}
	},
	async mounted() {
		this.onResize()
		window.addEventListener('resize', this.onResize)
		// user name

		if (localStorage.getItem('token') && localStorage.getItem('login')) {
		let roleId = await requestHelper.request(`/getUserRoleId`, null, 'get');
		roleId = roleId.data.data.userRoleId;

		const userPermissions = await requestHelper.request(`/getUserRolePermission/${roleId}`, null, 'get');
		const permissions = userPermissions.data.data;
		console.log('userPermissions - App', userPermissions.data.data);
		this.$store.commit('setUserPermissionArray', permissions);
		const permissionsObj = {};

		for (const module in permissions) {
			const { moduleName, permissionList } = permissions[module];
			permissionList.forEach(permission => {
			const lowerCasePermissionName = permission.name.toLowerCase();
			if (!permissionsObj[lowerCasePermissionName]) {
				permissionsObj[lowerCasePermissionName] = [];
			}
			if (!permissionsObj[lowerCasePermissionName].includes(moduleName)) {
				permissionsObj[lowerCasePermissionName].push(moduleName);
			}
			});
		}

		let permissionsArray = [];

		for (const [action, entities] of Object.entries(permissionsObj)) {
			entities.forEach(entity => {
			permissionsArray.push(`${action}${entity}`);
			});
		}
		// console.log('permissionsArray', permissionsArray);

		this.$store.commit('setPermissions', permissionsArray);
		}
	}
	}
	</script>
